// src/pages/Login.jsx
import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase/firebase";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email.trim(), pwd);
      navigate("/dashboard");
    } catch (e) {
      setErr(e.message || "Error al iniciar sesión.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 text-gray-900">
      <div className="w-[380px] rounded-xl border border-gray-200 bg-white p-7 shadow-sm">
        <h1 className="text-center text-xl font-semibold mb-6">Motofeel Admin</h1>

        <form className="space-y-4" onSubmit={onSubmit}>
          <div>
            <label className="text-sm text-gray-600">Correo</label>
            <input
              className="mt-1 w-full px-3 py-2 rounded border border-gray-300 bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="usuario@motofeel.com"
              required
            />
          </div>

          <div>
            <label className="text-sm text-gray-600">Contraseña</label>
            <input
              className="mt-1 w-full px-3 py-2 rounded border border-gray-300 bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              type="password"
              placeholder="••••••••"
              required
            />
          </div>

          {err && <p className="text-sm text-red-600">{err}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 rounded-md font-semibold bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-50"
          >
            {loading ? "Ingresando…" : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}